import React, { useState } from "react";
import { Link } from "react-router-dom";
import { lines, login02, logo, logoCuidado } from "../../imagepath";
import { esCorreoValido } from "../../../utils/helpers";
import { solicitarRestablecerPin } from "../../../services/user";
import { ScaleLoader } from "react-spinners";
import { css } from "@emotion/react";
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

const OlvidePin = () => {
  const [enviado, setEnviado] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [correo, setCorreo] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviado(false);
    setLoading(true);
    if (!correo) {
      setEnviado(false);
      setLoading(false);
      setErrorMessage("Por favor, completa el campo correo electrónico.");
      return;
    }
    if (!esCorreoValido(correo)) {
      setEnviado(false);
      setLoading(false);
      setErrorMessage("Por favor, introduce un correo electrónico válido.");
      return;
    }

    try {
      var respuesta = await solicitarRestablecerPin(correo);
      setLoading(false);
      if (respuesta.ok === true) {
        setEnviado(true);
      } else {
        setErrorMessage(respuesta.mensaje);
      }
    } catch (error) {
      console.error("Error cancelando subscripcion :", error);
      setErrorMessage("Ha ocurrido un error, favor intentar mas tarde.");
    }

    setErrorMessage(null);
  };

  return (
    <div>
      {loading && (
        <div className="overlay-loading">
          <ScaleLoader
            css={override}
            size={150}
            color={"#4e57cd"}
            loading={loading}
          />
        </div>
      )}
      <div className="main-wrapper login-body">
        <div className="container-fluid px-0">
          <div className="row">
            {/* Login logo */}

            <div className="login-sec"></div>
            <div className="col-lg-6">
              <div className="log-img"></div>
            </div>

            {/* Login Content */}
            <div className="col-lg-6 login-wrap-bg">
              <div className="login-wrapper">
                <div className="loginbox">
                  <div className="login-right">
                    <div className="login-right-wrap">
                      <div className="logoHumano">
                        <Link to="/admin">
                          <img src={logo} alt="#" width={200} />
                        </Link>
                      </div>
                      <div className="logoCuidado">
                        <Link to="/login">
                          <img src={logoCuidado} alt="#" width={160} />
                        </Link>
                      </div>
                      <div className="titles">
                        <label className="title">
                          Solicitar cambio de pin{" "}
                        </label>
                        <label className="label-description  mb-5">
                          Favor ingresar su correo electrónico{" "}
                        </label>
                      </div>
                      {/* Form */}
                      {errorMessage && (
                        <div className="text-center text-danger mb-3">
                          {errorMessage}
                        </div>
                      )}
                      <form onSubmit={handleSubmit}>
                        <div className="form-group">
                          <label>
                            Correo Electrónico{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="email"
                            value={correo}
                            onChange={(e) => setCorreo(e.target.value)}
                          />
                        </div>
                        <div className="form-group login-btn">
                          <button
                            className="btn btn-primary btn-block"
                            type="submit"
                          >
                            Enviar
                          </button>
                        </div>
                      </form>
                      {/* /Form */}
                      {/* Mensaje de correo enviado */}
                      {enviado && (
                        <div className="alert alert-success" role="alert">
                          Se le ha enviado un correo con las instrucciones para
                          restablecer su PIN.
                        </div>
                      )}
                    </div>
                  </div>
                  <img className="login-lines" src={lines} />
                </div>
              </div>
            </div>
            {/* /Login Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OlvidePin;
